import React, {ReactNode, createContext, useContext, useState} from "react"


const progressContextValue = {
    progress: 0,
    setProgress: (_: number) => {}
} satisfies {
    progress: number
    setProgress: (n: number) => void
}

export const ProgressContext = createContext(progressContextValue)

export const useProgress = () => useContext(ProgressContext)

export function ProgressProvider({ children }: { children: ReactNode }) {
    const [progress, setProgress] = useState(0)
    return <ProgressContext.Provider value={{ progress, setProgress }}>{children}</ProgressContext.Provider>
}

export function CreatorProgressBar() {
    const { progress } = useProgress()
    return (
        <div id="creator-progress">
            <div className="progress-bar" style={{ width: `${Math.max(0, progress)}%` }}/>
        </div>
    )
}